import { type HttpClient } from '../useHttpClient';

export type RequestJourneyReportEmailParams = {
  destinationEmailAddresses: string[];
};

export const fetchRequestJourneyReportEmail =
  (httpClient: HttpClient) =>
  async (params: RequestJourneyReportEmailParams) => {
    const response = await httpClient.api('/journeys/report', {
      method: 'POST',
      body: JSON.stringify(params),
    });

    return response.json as Response;
  };
